/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_TitleInputs */

const en_pc_dl_title = /** @type {(inputs: Pc_Dl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download PdfCraft`)
};

const zh_pc_dl_title = /** @type {(inputs: Pc_Dl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 PdfCraft`)
};

/**
* | output |
* | --- |
* | "Download PdfCraft" |
*
* @param {Pc_Dl_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_title = /** @type {((inputs?: Pc_Dl_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_title(inputs)
	return zh_pc_dl_title(inputs)
});
export { pc_dl_title as "pc.dl.title" }